import { InventoryItem, InventoryItemLifecycleStatus } from './inventory-item';

export const InventoryItemStatus = {
  new: 'New',
  existing: 'Existing',
  updated: 'Updated',
  deleted: 'Deleted',
} as const;

export function normalizeStatus(
  status?: InventoryItemLifecycleStatus,
): InventoryItemLifecycleStatus {
  return status ?? InventoryItemStatus.new;
}

export function isDeleted(status?: InventoryItemLifecycleStatus): boolean {
  return status === InventoryItemStatus.deleted;
}

export function statusAfterEdit(
  status?: InventoryItemLifecycleStatus,
): InventoryItemLifecycleStatus {
  const current = normalizeStatus(status);

  return current === InventoryItemStatus.existing ||
    current === InventoryItemStatus.updated
    ? InventoryItemStatus.updated
    : current;
}

export function statusAfterAttachmentChange(
  status?: InventoryItemLifecycleStatus,
): InventoryItemLifecycleStatus {
  return statusAfterEdit(status);
}

export function statusAfterSubmit(
  status?: InventoryItemLifecycleStatus,
): InventoryItemLifecycleStatus {
  return isDeleted(status)
    ? InventoryItemStatus.deleted
    : InventoryItemStatus.existing;
}

export function applyStatusAfterSubmit(
  items: InventoryItem[],
): InventoryItem[] {
  return items.map((item) =>
    isDeleted(item.status)
      ? item
      : { ...item, status: statusAfterSubmit(item.status) },
  );
}
